//Prachi Tawde : 03-07-2023 : BT-108578 -  Breeze - Quick user switch - Start
import { memo } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader, BzModalTitle } from '../../components'
import { handleModal } from '../../redux/actions/modals';

const DeleteProfileConfirmationModal = ({ user, onDeleteProfileConfirmation }) => {
    const dispatch = useDispatch();

    const modals = useSelector(state => state?.modals?.modals);

    const onHide = () => {
        dispatch(handleModal([{ "DELETE_PROFILE_CONFIRMATION_MODAL": false }]));
    };


    return (
        <BzModal size='md' show={modals['DELETE_PROFILE_CONFIRMATION_MODAL']} onHide={onHide} id="TopModal" role="dialog" aria-hidden="true">
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0 pb-2'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <BzModalTitle className='font-medium font-size4 color-text'>Delete User</BzModalTitle>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={onHide}>&nbsp;</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody className='bdr-btm'>
                <Container className='p-0'>
                    <Row className='g-0'>
                        <Col>
                            <div className='font-regular font-size4 color-text'>Are you sure you want to delete the user
                                <span className='font-medium mx-2'>'{user?.userName}'</span>
                                <span className='color-subtext'>(User ID: {user?.userId})</span> ?
                            </div>
                        </Col>
                    </Row>                     
                </Container>
            </BzModalBody>
            <BzModalFooter className='p-2'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={2}>&nbsp;</Col>
                        <Col className='me-2'>
                        <BzButton className='btn btn-md btn-outline btn-block text-capitalize' onClick={onHide}>Cancel</BzButton> 
                        </Col>
                        <Col className='ms-2'>
                        <BzButton className='btn btn-md btn-primary btn-block text-capitalize ms-2' onClick={onDeleteProfileConfirmation.bind(this,user)}>Delete</BzButton>
                        </Col>
                    </Row>        
                </Container>
            </BzModalFooter>
        </BzModal>
    )
}

export default memo(DeleteProfileConfirmationModal)